import classNames from 'classnames';
import React from 'react';
import styles from './left-right-layout.scss';

interface Props {
  className?: string;
  children: any;
}

export const LeftRightLayout = ({ children, className }: Props) => {
  const [left, right] = React.Children.toArray(children);
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.left}>{left}</div>
      {right}
    </div>
  );
};
